import {
  PageContainer,
  PageHeader,
} from "@volca/ui/components/ui/page-components";
import { Stack } from "@volca/ui/components/ui/stack";
import { ChangelogFeed } from "./changelog-feed";

export default function ChangelogPage() {
  return (
    <PageContainer>
      <Stack gap={6} className="mx-auto w-full max-w-3xl">
        <PageHeader
          title="What’s new"
          description="The latest features, improvements, and fixes in Volca."
        />
        <ChangelogFeed />
      </Stack>
    </PageContainer>
  );
}
